<template>
  <div class="team-container">
    <div class="team-member" v-for="member in members" :key="member.name">
      <div class="image-container">
        <img :src="member.image" :alt="member.name" />
      </div>
      <h2>{{ member.name }}</h2>
      <h3>{{ member.role }}</h3>
      <p>{{ member.description }}</p>
      <div class="social-icons">
        <a
          :style="{ pointerEvents: member.social.facebook ? 'auto' : 'none' }"
          :href="member.social.facebook"
          target="_blank"
          ><img
            src="@/assets/icon-social-media/facebook-icon.png"
            alt="Facebook"
        /></a>
        <a :href="member.social.linkedin" target="_blank"
          ><img
            src="@/assets/icon-social-media/linkedin-icon.png"
            alt="LinkedIn"
        /></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MeetOurTeam",
  data() {
    return {
      members: [
        {
          name: "Dương Minh Hải",
          role: "Senior R&D Manager",
          description: "",
          image: "images/team/img.png",
          social: {
            facebook: "https://www.facebook.com/duong.minhhai.50",
            linkedin: "https://www.linkedin.com/in/harry179/",
          },
        },
        {
          name: "Hoàng Công Văn",
          role: "AI Engineer",
          description: "",
          image: "images/team/img_4.png",
          social: {
            facebook: "",
            linkedin: "https://www.linkedin.com/in/hcongvan94",
          },
        },
        {
          name: "Phan Văn Hưng",
          role: "AI Engineer",
          description: "",
          image: "images/team/img_1.png",
          social: {
            facebook: "",
            linkedin: "https://www.linkedin.com/in/hung-phan-/",
          },
        },
        {
          name: "Nguyễn  Minh Trí",
          role: "AI Engineer",
          description: "",
          image: "images/team/img_3.png",
          social: {
            facebook: "https://www.facebook.com/Mucian.Bean/",
            linkedin: "https://www.linkedin.com/in/nguyen-minh-tri-0a541716a/",
          },
        },
        {
          name: "Lê Văn Quang",
          role: "Fullstack Developer",
          description: "",
          image: "images/team/img_2.png",
          social: {
            facebook: "",
            linkedin: "https://www.linkedin.com/in/quangleit97/",
          },
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
body {
  font-family: "Arial", sans-serif;
  background-color: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
}

.team-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.team-member {
  background-color: #dadada;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  width: 200px;
}

.team-member:hover {
  transform: scale(1.05);
}

.image-container {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0 auto 10px;
  border-radius: 50%;
  border: 5px solid #2e8b57;
  padding: 12px;
  box-sizing: border-box;
  background-color: #fff;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.team-member h2 {
  margin: 10px 0 5px;
  font-size: 1.2em;
  font-weight: 800;
  color: #2e8b57;
}

.team-member h3 {
  margin: 5px 0;
  font-size: 1em;
  color: #777;
}

.team-member p {
  font-size: 0.9em;
  color: #555;
}

.social-icons {
  margin-top: 10px;
}

.social-icons a {
  margin: 0 5px;
  display: inline-block;
}

.social-icons img {
  width: 24px;
  height: 24px;
}

@media (max-width: 768px) {
  .team-container {
    flex-direction: column;
    align-items: center;
  }

  .team-member {
    width: 100%;
    max-width: 300px;
  }
}

/* Include your styles here */
</style>
